export function createFeatureMatchingAssessmentConfig() {
	return {
		title: "AAC Feature-Matching Assessment",
		instructions: "Document the person's abilities, needs, and contexts. Record system-feature requirements and explain how each supports communication or access. Consider communication functions, partners and environments, symbols and display, input and output, positioning and accessories, portability, adaptability, preference, and maintenance where relevant.",
		showPriorResults: true,
		stages: [
			{id: "communication", title: "Communication"},
			{id: "access", title: "Access"},
			{id: "sensory", title: "Sensory"},
			{id: "motor", title: "Motor"},
			{id: "environmental", title: "Environmental"},
		].map(row => ({...row, allowAlternatives: false, itemPlaceholder: "Required system feature"})),
		linkedRequirements: {
			needQuestion: "What documented ability, need, or context should the AAC system support?",
			evidenceQuestion: "What observation or source supports this need?",
			contextQuestion: "Where or with whom does this need arise?",
			requirementQuestion: "What system feature is required?",
			rationaleQuestion: "Why does this feature matter for access or communication?",
			unresolvedQuestion: "What questions remain unresolved?",
			themeQuestion: "What assessment theme should guide the next AAC comparison?",
			needsTitle: "Documented needs and contexts",
			requirementsTitle: "System-feature requirements",
			coverageTitle: "Dimensions considered",
			summaryTitle: "Requirements and rationale",
			missingRationaleLabel: "Rationale needed",
			missingLinkLabel: "Documented need needed",
			unmatchedNeedLabel: "No matched feature yet",
			unconsideredLabel: "Not yet considered",
			consideredLabel: "Considered",
			requirementCountLabel: "requirements",
			emptyRequirementsLabel: "No requirements recorded.",
			linkedNeedsLabel: "Linked documented needs",
			addNeedLabel: "Add documented need",
			addRequirementLabel: "Add requirement",
			requirementPlaceholder: "Required system feature",
			needPlaceholder: "Documented ability, need, or context",
			narrowFocusLabel: "Only one dimension has requirements while other included dimensions remain unconsidered.",
			evidenceLabel: "Evidence or source",
			contextLabel: "Context",
			priorTitle: "Reassessment changes",
			reviseActionLabel: "Reassess requirements",
			saveRevisionLabel: "Save reassessment",
			changedNeedLabel: "Changed need or context",
			earlierNeedLabel: "Earlier need or context",
			changedRequirementLabel: "Added or revised requirement",
			retainedRequirementLabel: "Retained requirement",
			earlierRequirementLabel: "Earlier requirement",
			archivedRequirementsTitle: "Requirements from removed dimensions",
			groupingOptions: [
				{id: "dimension", title: "By dimension", mode: "dimension"},
				{id: "context", title: "By context", mode: "context"},
				{id: "accessNeed", title: "By access need", mode: "accessNeed"},
			],
			groupingId: "dimension",
		},
	}
}

export function createFeatureMatchingAssessmentDemoPayload() {
	return {
		stagedWorksheet: {
			theme: "Keep request vocabulary available across classroom and outdoor routines.",
			linkedRequirements: {
				needs: [
					{id: "requestClass", text: "Mara needs to make requests during classroom activities, and her speech is often hard for classmates to understand.", context: "Classroom activities", evidence: "Teacher observation during group work"},
					{id: "outdoors", text: "Mara needs to communicate reliably outdoors.", context: "Playground", evidence: "Family and teacher report"},
					{id: "visual", text: "Mara needs clear visual access to vocabulary.", context: "Classroom and home", evidence: "Observed difficulty with small symbols"},
				],
				consideredDimensionIds: ["communication", "access"],
				unresolvedQuestion: "Which display size remains readable in bright outdoor light?",
			},
			stages: [
				{id: "communication", items: [{id: "quickRequests", text: "Quick access to request vocabulary", values: {needIds: ["requestClass"], rationale: "Mara can make timely requests during classroom activities without relying on speech alone."}}]},
				{id: "access", items: [{id: "portable", text: "Portable access across settings", values: {needIds: ["outdoors"], rationale: "The communication system must be available when Mara moves from class to the playground."}}]},
			],
		},
	}
}
